module.exports = __webpack_public_path__ + "static/img/hospital_img.9042795.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctors/hospital_img.png
// module id = 9wVr
// module chunks = 7